<template>
  <div class="product-gallery">
    <h2 class="product-gallery__title">
      {{ title }}
    </h2>

    <swiper
      class="product-gallery"
      :items="products"
      v-slot="{ item }"
      :slides-to-show="slidesToShow"
      dots
      :arrows="adaptive.isDesktop"
      @change="onChangeSlide"
    >
      <product-list-item
        :product="item"
      />
    </swiper>
  </div>
</template>

<script>
import ProductListItem from '@/components/catalog/product-list-item';
import gtmEventsMixin from '@/mixins/gtm-events-mixin';

export default {
  name: 'product-gallery',

  components: {
    ProductListItem
  },

  mixins: [gtmEventsMixin],

  inject: {
    adaptive: 'adaptive',
    maxGalleryProducts: { default: 6 },
  },

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    slidesToShow() {
      switch (true) {
        case this.adaptive.isMobile: return 2;
        case this.adaptive.isTablet: return 4;
        default: return this.maxGalleryProducts;
      }
    }
  },

  methods: {
    onChangeSlide() {
      this.gtmEvents.scrollProducts();
    },
  }
};
</script>

<style lang="scss">
.product-gallery {
  &__title {
    font-weight: 300;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 24px;

    @include breakpoint("desktop") {
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 32px;
    }
  }
}
</style>
